const mobileScreen = window.matchMedia('(max-width: 767.98px)');

function updateHeroBackgrounds() {
    document.querySelectorAll('.home-hero [data-background-image-mobile]').forEach(element => {
        const desktopImage = element.getAttribute('data-background-image-desktop');
        const mobileImage = element.getAttribute('data-background-image-mobile');
        const image = mobileScreen.matches ? mobileImage || desktopImage : desktopImage || mobileImage;

        element.setAttribute('data-background-image', image);
        if (element.getAttribute('data-loaded') === 'true') {
            element.style.backgroundImage = `url(${JSON.stringify(image)})`;
        }
    });
}

// Select the image before Lozad observes the hero, and update it across breakpoints.
updateHeroBackgrounds();
if (mobileScreen.addEventListener) {
    mobileScreen.addEventListener('change', updateHeroBackgrounds);
} else {
    mobileScreen.addListener(updateHeroBackgrounds);
}
